import React, { useState } from "react";
import "./referForm.scss";
import BreadCrumsHeader from "../../common/BreadCrums";
import Input from "../../common/FormInputs";
import PhoneFormInput from "../../common/PhoneInput";
import InputTextArea from "../../common/InputTextArea";
import { ReactComponent as CameraIcon } from "../../../Assets/Icons/cameraIcon.svg"; // (no longer used; kept only if referenced elsewhere)
import { useFormik } from "formik";
import { referSchema } from "../../../utils/validationSchemas";
import GoogleMaps from "../../common/GoogleMaps";
import { referMerchant, getFundraiserProfile } from "../../../services/fundraiserService";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "../../../utils/toast";
import Loader from "../../common/Loader";
// import { uploadFile } from "../../../utils/s3";

const ReferFormPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state?.fundraiserReducer?.loading);
  const [fundraiserLogo, setFundraiserLogo] = useState("");

  const resolveUrl = (path) => {
    if (!path) return "";
    if (/^https?:\/\//i.test(path)) return path;
    return `${process.env.REACT_APP_S3_URL || ""}${path}`;
  };

  React.useEffect(() => {
    const fetchProfileLogo = async () => {
      try {
        const res = await getFundraiserProfile();
        const raw = res?.data?.logo || res?.data?.profileImage || res?.data?.user?.logo;
        setFundraiserLogo(resolveUrl(raw));
      } catch (_) {
        setFundraiserLogo("");
      }
    };
    fetchProfileLogo();
  }, []);

  const handleLocationSelect = (selectedLocation) => {
    formik.setFieldValue("location", selectedLocation?.placeName);
  };

  const formik = useFormik({
    initialValues: {
      merchantName: "",
      email: "",
      contact: "",
      message: "Hi there!\n\nI hope this message finds you well. I'm reaching out to introduce you to Swoodle, an innovative fundraising platform that could be a great fit for your business.\n\nSwoodle offers a unique opportunity for merchants to partner with local fundraisers and organizations, helping them raise funds while driving customers to your business. It's a win-win situation that benefits both your business growth and the community.\n\nKey benefits include:\n• Increased foot traffic and sales\n• Community engagement and goodwill\n• Simple setup and management\n• Dedicated support team\n\nI believe your business would be a perfect addition to our network. Would you be interested in learning more about how Swoodle can help grow your business while supporting local causes?\n\nI'd be happy to arrange a brief call to discuss this opportunity further.\n\nBest regards,",
      website: "",
      location: "",
      // merchant logo upload removed
    },
    validationSchema: referSchema,
    onSubmit: async (values, { resetForm }) => {
      const referPromise = await dispatch(
        referMerchant({
          name: values?.merchantName,
          email: values?.email,
          contactNumber: values?.contact,
          description: values?.message,
          website: values?.website,
          location: values?.location,
          // merchant logo removed from payload
        })
      ).unwrap();
      if (referPromise?.success === true) {
        toast.success("Referral sent successfully!");
        resetForm();
        navigate("/fundraiser/referral-list");
      }
    },
  });

  const items = [
    {
      title: "Refer a Merchant",
    },
    {
      title: "Refer New Merchant",
    },
  ];

  return (
    <>
      {loading && <Loader />}
      <div className="flex flex-col gap-5">
        {/* Fundraiser logo/avatar box: show logo when present; else only the camera icon without any text */}
        <div className="pl-[2%] pt-2">
          <div className="relative h-[80px] w-[80px] rounded-[10px] border-2 border-solid border-[#E4E3E4] overflow-hidden flex justify-center items-center bg-white">
            {fundraiserLogo ? (
              <img
                src={fundraiserLogo}
                alt="Fundraiser Logo"
                className="w-full h-full object-cover object-center"
              />
            ) : (
              <CameraIcon />
            )}
          </div>
        </div>
        <BreadCrumsHeader
          heading="Refer New Merchant"
          items={items}
          form={true}
        />
      </div>
      <div className="bg-white rounded-lg shadow-md mt-5 pt-4">
        <h2 className="text-lg font-semibold mb-6 px-8">Merchant details</h2>
        <hr />
        <form onSubmit={formik.handleSubmit} className="p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-8">
            <Input
              label="Business Name"
              placeholder="Enter merchant name"
              name="merchantName"
              value={formik.values.merchantName}
              handleChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              error={formik.errors.merchantName}
              touched={formik.touched.merchantName}
              width="100%"
              radius="4px"
            />
            <Input
              label="Email"
              placeholder="Enter email address"
              name="email"
              value={formik.values.email}
              handleChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              error={formik.errors.email}
              touched={formik.touched.email}
              width="100%"
              radius="4px"
            />
            <Input
              label={
                <span>
                  Website URL <span style={{ color: '#999999', fontWeight: 'normal' }}>(Optional)</span>
                </span>
              }
              placeholder="Add URL"
              name="website"
              value={formik.values.website}
              handleChange={formik.handleChange}
              handleBlur={formik.handleBlur}
              error={formik.errors.website}
              touched={formik.touched.website}
              width="100%"
              radius="4px"
            />
            <PhoneFormInput
              label={
                <span>
                  Contact no. <span style={{ color: '#999999', fontWeight: 'normal' }}>(Optional)</span>
                </span>
              }
              divClassName="w-full mt-8"
              name="contact"
              value={formik.values.contact}
              handleBlur={() => formik.setFieldTouched("contact", true)}
              error={formik.errors.contact}
              touched={formik.touched.contact}
              setFieldValue={formik.setFieldValue}
              inputStyle={{
                width: "100%",
                border: "none",
              }}
              buttonStyle={{ border: "none" }}
              buttonClass="!rounded-l-[5px] !bg-[#D9D9D9] md:!w-[13%] sm:!w-[15%] lg:!w-[9%] xl:!w-[7%] 2xl:!w-[6%]"
              containerClass="!rounded-[5px] border border-[#D9D9D9] z-[9999]"
              inputClass="lg:!h-[45px] md:!h-[45px] !rounded-[5px] !bg-[#FFFFFF] !text-[#303030] lg:!text-[16px] sm:!text-[14px] !font-[400] !outline-none !font-poppins md:!pl-[17%] sm:!pl-[17%] lg:!pl-[11%] xl:!pl-[9%] 2xl:!pl-[8%]"
              labelClass="invitationLabels"
              errorClass={
                "text-red-600 sm:text-[10px] md:text-[12px] font-[600] ms-1"
              }
            />
          </div>

          <div className="mt-8">
            <p className="text-sm text-gray-600">
              Enter your business address into the search bar, below. When the
              correct address appears, press Enter to confirm.
            </p>
            <div className="relative mt-4" style={{ height: "400px" }}>
              <GoogleMaps
                onLocationSelect={handleLocationSelect}
                searchBarParentClassName="absolute top-[10px] left-0 right-0 mx-auto z-10 w-[320px]"
              />
            </div>
            <Input
              divClassName="mt-4"
              placeholder="Business address will be displayed here"
              name="location"
              value={formik.values.location}
              disabled={true}
              handleChange={formik.handleChange}
              width="100%"
              InputDivClass="w-full"
              radius="4px"
            />
          </div>

          <div className="mt-8">
            <InputTextArea
              label={"Message"}
              name="message"
              value={formik.values.message}
              handleBlur={formik.handleBlur}
              error={formik.errors.message}
              touched={formik.touched.message}
              setFieldValue={formik.setFieldValue}
              textareaClassName="w-full h-[150px] px-3 py-2 rounded-md bg-white border border-gray-300 text-gray-800 text-sm font-normal outline-none resize-none font-poppins mt-5"
              placeholder="Type your message here..."
              showCounter={false}
              maxCharacters={null}
            />
          </div>

          <div className="mt-8 flex justify-end">
            <button
              type="submit"
              className="px-8 py-2 bg-[#00AEEF] text-white rounded-md hover:bg-opacity-90"
            >
              Send
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ReferFormPage;
